import { Component, OnInit, ViewChild } from '@angular/core';


import { UserblockService } from '../sidebar/userblock/userblock.service';
import { SettingsService } from '../../core/services/settings.service';
import { MenuService } from '../../core/services/menu.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { SweetAlertService } from '../../core/services/sweet-alert.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public navCollapsed = true; // for horizontal layout
  public menuItems = []; // for horizontal layout

  public isNavSearchVisible: boolean;

  constructor(public menu: MenuService, public userblockService: UserblockService, public settings: SettingsService, public auth: OAuthService, private readonly sw: SweetAlertService, ) {

    // show only a few items on demo
    this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout

  }

  public ngOnInit() {
    this.isNavSearchVisible = false;
  }

  public toggleUserBlock(event) {
    event.preventDefault();
    this.userblockService.toggleVisibility();
  }

  public openNavSearch(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setNavSearchVisible(true);
  }

  public setNavSearchVisible(stat: boolean) {
    // console.log(stat);
    this.isNavSearchVisible = stat;
  }

  public getNavSearchVisible() {
    return this.isNavSearchVisible;
  }

  public toggleOffsidebar(ev: Event) {
    ev.preventDefault();
    ev.stopPropagation();
    this.settings.toggleLayoutSetting('offsidebarOpen');


  }

  public toggleCollapsedSideabar(ev: Event) {

    ev.preventDefault();

    this.settings.toggleLayoutSetting('isCollapsed');
  }

  public isCollapsedText() {
    return this.settings.getLayoutSetting('isCollapsedText');
  }

  public logOut(ev: Event) {
    ev.preventDefault();

    this.sw.confirm({ title: `Logout`, html: `Are you sure you want to logout?` })
      .then((confirm) => {
        if (confirm && confirm.value) {
          this.auth.logOut();
        }
      });
  }
}
